import { useEffect } from 'react';

/** Lance `run` après le premier rendu validé (les @font-face injectés par <Fonts /> existent alors). */
export function AfterFirstCommit({ run }: { run: () => void }) {
  useEffect(run, [run]);
  return null;
}
